// src/components/Footer/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3>Vista Elevations Pvt. Ltd</h3>
              <p>Your trusted technology partner for IT solutions, cloud services, and digital transformation.</p>
              <div className="footer-contact">
                <p><strong>📍 Location:</strong> Delhi, India</p>
                <p><strong>📞 Phone:</strong> +91 93118 45556</p>
              </div>
            </div>

            <div className="footer-column">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Our Services</h4>
              <ul>
                <li>IT Infrastructure Solutions</li>
                <li>Software Development</li>
                <li>Cloud & Managed Services</li>
                <li>Data & Analytics</li>
                <li>Cybersecurity Solutions</li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Connect With Us</h4>
              <div className="social-links">
                <a href="#facebook" className="social-link" aria-label="Facebook">
                  <span>f</span>
                </a>
                <a href="#linkedin" className="social-link" aria-label="LinkedIn">
                  <span>in</span>
                </a>
                <a href="#twitter" className="social-link" aria-label="Twitter">
                  <span>𝕏</span>
                </a>
                <a href="#instagram" className="social-link" aria-label="Instagram">
                  <span>📷</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Vista Elevations Pvt. Ltd. All Rights Reserved.</p>
            <div className="footer-bottom-links">
              <a href="#privacy">Privacy Policy</a>
              <span>|</span>
              <a href="#terms">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;